export default "__VITE_ASSET__DAhCs4Zk__"